import * as React from "react";
import * as S from "@styled";
import CustomModal from "./CustomModal";
import { MultiCreatable } from "./select/Select";
import { Option } from "shared/model/Option";
import { selectPlaceHolderText } from "./TagModal";

const BatchTagModal: React.FC<IBatchTagModalProps> = (props) => {
    const [state, setState] = React.useState<{ selectedTags: string[], inputValue: string }>({ selectedTags: [], inputValue: "" });

    const handleChangeSelectedTags = (newSelection: Option[]) => {
        setState(prevState => ({ ...prevState, selectedTags: newSelection && newSelection.map((o) => o.value.toString()) || [] }));
    }

    const handleTagAdd = () => {
        props.onAddTags(state.selectedTags);
    }

    const handleTagOverwrite = () => {
        props.onOverwriteTags(state.selectedTags);
    }

    return (
        <CustomModal
            label="tagModal"
            onClose={props.onCancel}
            show={true}
            shouldCloseOnOverlayClick={true}
            modalTitle={<h2>{FRENDS.Localizations.EditTags}</h2>}
        >
            <S.FormGroup>
                <S.Label>{FRENDS.Localizations.BatchTagDescription}</S.Label>
                <MultiCreatable
                    options={props.availableTags}
                    className="tag-select"
                    value={state.selectedTags.map((val) => ({ label: val, value: val }))}
                    onChange={handleChangeSelectedTags}
                    placeholder={selectPlaceHolderText}
                    autoFocus={true}
                    menuPortalTarget={document.body}
                />
            </S.FormGroup>
            <S.ButtonGroup $justifyContentEnd={true} gap={10}>
                <S.Button variant={S.ButtonType.bordered} onClick={props.onCancel}>{FRENDS.Localizations.Cancel}</S.Button>
                <S.Button onClick={handleTagAdd}>{FRENDS.Localizations.TagAdd}</S.Button>
                <S.Button onClick={handleTagOverwrite}>{FRENDS.Localizations.TagOverwrite}</S.Button>
            </S.ButtonGroup>
        </CustomModal>
    )
}

interface IBatchTagModalProps {
    availableTags: Option[];
    onAddTags: (tags: string[]) => void;
    onOverwriteTags: (tags: string[]) => void;
    onCancel: () => void;
}

export default BatchTagModal;